export default __webpack_public_path__ + "static/media/archived campaign.011d40ab.svg";